import React from 'react';
import './CAAPartnership.css';
import ExecutiveSummary from './ExecutiveSummary';
import TopInfluencers from './TopInfluencers';
import IndustryDistribution from './IndustryDistribution';
import EngagementAnalysis from './EngagementAnalysis';
import BrandPartnerships from './BrandPartnerships';
import InvestmentMatrix from './InvestmentMatrix';
import CallToAction from './CallToAction';

const CAAPartnership = () => {
  return (
    <div className="caa-partnership">
      <div className="partnership-header">
        <h1 className="partnership-title">
          Unlocking Celebrity-Driven Investment Power
        </h1>
      </div>

      <div className="partnership-content">
        <ExecutiveSummary />
        
        <div className="visualizations-grid">
          <div className="viz-row">
            <TopInfluencers />
            <IndustryDistribution />
          </div>
          
          <div className="viz-row">
            <EngagementAnalysis />
            <BrandPartnerships />
          </div>
          
          <div className="viz-row">
            <InvestmentMatrix />
          </div>
        </div>

        <CallToAction />
      </div>
    </div>
  );
};

export default CAAPartnership;